import React from 'react';
import './Loading.scss'; 

export default function Loading() {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
}

